var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tabs.length > 0 && _vm.defaultTab.name !== undefined
    ? _c("div", { staticClass: "vertical-tabs-container" }, [
        _c(
          "div",
          { staticClass: "vertical-tabs" },
          [
            _vm._l(_vm.filteredTabs, function (tab, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "vertical-tab pa-4",
                  class: { "vertical-tab-active": tab === _vm.activeTab },
                  on: {
                    click: function ($event) {
                      return _vm.switchTab(tab)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pa-2" }, [_vm._t("after-tabs")], 2),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vertical-tabs-contents pa-3" },
          [
            _c(
              "Transition",
              {
                attrs: { name: _vm.transitionName, mode: "out-in", appear: "" },
              },
              [
                _c(
                  "div",
                  {
                    key: _vm.tabs.indexOf(_vm.activeTab),
                    staticClass: "vertical-tabs-content",
                  },
                  [_vm._t(_vm.activeTab.name)],
                  2
                ),
              ]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }